import { DatadogUrlsStatusType } from '@tiendanube/common';
import axios from 'App/axios';

export const fetchRoutesToWatch = async () => {
  const { data } = await axios.get<DatadogUrlsStatusType>(
    `/v1/datadog/stratus-url-to-watch`,
  );
  return data;
};
